import { graphql, useStaticQuery } from 'gatsby';
import { getCountryCodeFromIp, getTerritoryFromCountry } from 'helpers/Country';
import { useEffect } from 'react';
import { useState } from 'react';

export const useGeoLocalizedCustomerLogos = (useGlobalLogos) => {
    const [countryCode, setCountryCode] = useState(null);
    const [territory, setTerritory] = useState(null);
    const [geoLocalizedLogos, setGeoLocalizedLogos] = useState();

    const { allSanityGeoLocalizedCustomerLogos } = useStaticQuery(graphql`
        query {
            allSanityGeoLocalizedCustomerLogos {
                nodes {
                    identifier
                    locationCode
                    logos {
                        description
                        image {
                            asset {
                                gatsbyImageData(width: 170, placeholder: NONE)
                            }
                        }
                    }
                }
            }
        }
    `);

    const { nodes } = allSanityGeoLocalizedCustomerLogos;
    return { geoLocalizedLogos: nodes.find((x) => x.locationCode === 'global').logos };

    // useEffect(() => {
    //     if (!useGlobalLogos) {
    //         getCountryCodeFromIp(setCountryCode);
    //     } else {
    //         setTerritory({ id: 'global' });
    //     }
    // }, [useGlobalLogos]);

    // useEffect(() => {
    //     if (countryCode) {
    //         setTerritory(getTerritoryFromCountry(countryCode));
    //     }
    // }, [countryCode]);

    // useEffect(() => {
    //     const getLogoLineupFromTerritory = () => {
    //         if (territory) {
    //             if (
    //                 territory.id === 'norway' ||
    //                 territory.id === 'sweden' ||
    //                 territory.id === 'nordics'
    //             ) {
    //                 return nodes.find((x) => {
    //                     return x.locationCode === 'nordics';
    //                 });
    //             }
    //             if (territory.id === 'amer') {
    //                 return nodes.find((x) => {
    //                     return x.locationCode === 'amer';
    //                 });
    //             }
    //             if (territory.id === 'uki') {
    //                 return nodes.find((x) => {
    //                     return x.locationCode === 'uki';
    //                 });
    //             }
    //             if (territory.id === 'global') {
    //                 return nodes.find((x) => {
    //                     return x.locationCode === 'global';
    //                 });
    //             }

    //             return nodes.find((x) => {
    //                 return x.locationCode === 'amer';
    //             });
    //         }

    //         return null;
    //     };

    //     setGeoLocalizedLogos(getLogoLineupFromTerritory());
    // }, [territory, nodes]);

    // return {
    //     geoLocalizedLogos
    // };
};
